import { MutableRefObject } from "react"
import { ReactFlowInstance } from "reactflow"
import { uuidv7 } from "uuidv7"
import { CanvasNodes, SetNodesState, UISheetType } from "../types/UITypes"
import { SupabaseConnector, supabase } from "../database/SupabaseConnector"
import { DBEntityType } from "../types/SupabaseTypesHelper"
import { CELL_WIDTH } from "./constants"

export async function addSheet(
  annotationType: UISheetType,
  setNodes: SetNodesState,
  reactFlowRef: MutableRefObject<ReactFlowInstance | null>,
  supabaseConnector: SupabaseConnector,
  canvasId: string
) {
  const nodes = reactFlowRef.current?.getNodes() || []
  const sheetWidth = 250
  const sheetHeight = 115
  const centerCoords = reactFlowRef.current?.project({
    x: (window.innerWidth - sheetWidth) / 2,
    y: (window.innerHeight - sheetHeight) / 2,
  })

  const sheetId = uuidv7()
  const cells = [
    {
      id: uuidv7(),
      rowIndex: 1,
      columnIndex: 1,
      sheetId: sheetId,
    },
  ]
  const columns = [
    {
      id: uuidv7(),
      columnIndex: 1,
      sheetId: sheetId,
      width: CELL_WIDTH,
    },
  ]
  const addedSheet = {
    id: `sheet-${sheetId}`,
    position: {
      x: centerCoords?.x || 0,
      y: centerCoords?.y || 0,
    },
    data: {
      id: sheetId,
      x: centerCoords?.x || 0,
      y: centerCoords?.y || 0,
      cells,
      columns,
      edgeHandles: [],
      entityType: UISheetType.SHEET,
    },
    width: sheetWidth,
    height: sheetHeight,
    type: annotationType,
  }

  const updatedNodes = [...nodes, addedSheet]

  setNodes(updatedNodes)
  const isMatrix = annotationType === UISheetType.MATRIX

  await supabaseConnector.addSheet(
    centerCoords!,
    sheetId,
    cells,
    columns,
    DBEntityType[annotationType]
  )

  if (isMatrix) {
    await supabase
      .from("column_label_label")
      .insert({ canvas_id: canvasId, sheet_id: sheetId, text: "" })
    await supabase
      .from("row_label_label")
      .insert({ canvas_id: canvasId, sheet_id: sheetId, text: "" })
  }

  return addedSheet
}
